module.exports = __webpack_public_path__ + "static/media/live-on-logo.28eb4770.png";